<template>
  <a-modal :title="project?'项目通知详情':'通知详情'"
           :visible="visible"
           width="1250px"
           @cancel="$emit('cancel',project)"
           :maskClosable="false"
           :footer="null"
           :destroyOnClose="true"
  >
    <a-card>
      <table class="fx-form-view">
        <tr>
          <th>通知标题</th>
          <td colspan="3">{{ notice.title }}</td>
        </tr>
        <tr>
          <th>发布人</th>
          <td>广东志正招标有限公司</td>
          <th>发布日期</th>
          <td>{{ notice.extras.publishDate}}</td>
        </tr>
        <tr>
          <td colspan="4">
            <div class="rich-article" v-html="notice.content"></div>
          </td>
        </tr>
          <tr>
              <th>附件</th>
              <td colspan="3">
                   <upload-selector-view  @change="uploadSelectorChange" readonly :referId='notice.id' configKey='bid_notice_file'></upload-selector-view>
              </td>
          </tr>
      </table>
    </a-card>
  </a-modal>
</template>

<script>
import qs from 'qs'
import moment from 'moment'
import UploadSelectorView from "../../components/selector/UploadSelectorView";

export default {
  name: 'SupplierNoticeView',
  props:['visible'],
  components: {
    moment,
    UploadSelectorView
  },
  data() {
    return {
      notice:{extras:{}
      },
      fileLength:0,
      project:{}
    }
  },
  created() {
  },
  methods: {
    uploadSelectorChange(fileLength){
      this.fileLength = fileLength
    },
    onLoad(id,item) {
      let that = this
      that.project=item
      that.$http.get('/api/v1/supplier/notice/getBidNoticeById.json?id=' + id).then(function (response) {
        if (response.code !== 200) {
          that.$message.error('获取失败')
          return
        }
          that.notice = response.result
      })
    },
  }
}
</script>

<style scoped>
.insert {
  top: -400px;
}
</style>
